import { SETTINGS } from '../../utils/constants';
import { throttle } from 'throttle-debounce';

const initCategoryScrollIndicator = () => {
  const wrapperEl = document.querySelector('[data-category-scroll]');
  if (!wrapperEl || wrapperEl.dataset.scrollIndicatorInit) return;
  wrapperEl.dataset.scrollIndicatorInit = 'true';

  const listEl = wrapperEl.querySelector('[data-category-list]');
  const indicatorEl = wrapperEl.querySelector('[data-category-scroll-indicator]');
  if (!listEl || !indicatorEl) return;

  const toggleIndicator = () => {
    const isAtEnd = listEl.scrollLeft + listEl.clientWidth >= listEl.scrollWidth - SETTINGS.SCROLL_END_TOLERANCE;
    indicatorEl.hidden = isAtEnd;
  };

  toggleIndicator();
  listEl.addEventListener('scroll', throttle(SETTINGS.THROTTLE_DELAY_SMALL, toggleIndicator));
  window.addEventListener('resize', throttle(SETTINGS.THROTTLE_DELAY, toggleIndicator));
};

export default initCategoryScrollIndicator;
